<template>
  <div>
    <b-modal
      id="modal-assign-secondary-process"
      ref="modal-assign-secondary-process"
      centered
      :title="$t('DEBTIA_ASSIGN_SECONDARY_PROCESS')"
      :ok-title="$t('DEBTIA_ASSIGN')"
      :no-close-on-backdrop="true"
      cancel-variant="outline-secondary"
      size="lg"
      hide-footer
      @close="resetProcessChangeModal"
    >
      <b-overlay
        id="overlay-background"
        :show="loader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          v-if="errorMsg"
          variant="warning"
          show
        >
          <div
            v-if="typeof errorMsg === 'string'"
            class="alert-body"
          >
            <span>{{ errorMsg }}</span>
          </div>
          <div
            v-else
            class="alert-body"
          >
            <span
              v-for="msg in errorMsg"
              :key="msg"
            >{{ msg }}</span>
          </div>
        </b-alert>
        <b-form
          ref="form"
          class="repeater-form"
        >

          <!-- Row Loop -->
          <b-row ref="row">

            <!-- Cost -->
            <b-col
              md="6"
            >
              <b-form-group
                :label="$t('DEBTIA_PROCESS')"
                label-for="case-process"
              >
                <v-select
                  v-model="processID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="processes"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="case-process"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="4"
            >
              <b-button
                variant="primary"
                class="mt-2"
                @click="submitHandler"
              >
                <span class="text-nowrap">{{ $t('DEBTIA_ASSIGN') }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
        <hr>
        <h5>{{ $t('DEBTIA_ACTIVE_SECONDARY_PROCESSES') }}</h5>
        <b-table
          v-if="processData.length > 0"
          ref="refUserListTable"
          class="position-relative resource-listing assign-sec-proccess"
          responsive
          :fields="tableFields"
          :items="processData"
        >
          <template #cell(action)="data">
            <b-link
              class="font-weight-bold d-block text-nowrap"
              @click="deleteProcess(data.item)"
            >
              <feather-icon
                icon="TrashIcon"
                class="mt-2"
              />
            </b-link>
          </template>
          <template #cell(current_module)="data">
            <span class="main-text">
              {{ data.item.current_module }}
              <small v-if="data.item.execution_date">
                ({{ $t('DEBTIA_CASE_CONTINUE_ON') }}
                {{ ($i18n.locale === 'en') ? data.item.en_execution_date : data.item.da_execution_date }})
              </small>
            </span>

            <label
              v-if="data.item.error"
              class="ml-1 mr-2 error-color"
            >
              <div class="alert-body">
                <strong>Error: </strong>{{ JSON.parse(data.item.error)[0] }}
              </div>
            </label>
          </template>

        </b-table>
        <b-alert
          v-else
          variant="primary"
          show
        >
          <div class="alert-body">
            <span>{{ $t('DEBTIA_NO_SECONDARY_PROCESS_TEXT') }}</span>
          </div>
        </b-alert>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol,
  BFormGroup,
  BForm,
  BAlert,
  BOverlay,
  BTable,
  BLink,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { EventBus } from '@/event-bus'
import axios from '@axios'
import vSelect from 'vue-select'
import i18n from '@/libs/i18n'

export default {
  components: {
    vSelect,
    BOverlay,
    BAlert,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BTable,
    BLink,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    caseId: {
      type: [Number, String],
      required: true,
    },
    secondaryProcessesData: {
      type: Array,
      required: true,
    },
    getSecondaryProcesses: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      processID: null,
      loader: false,
      required,
      errorMsg: '',
      processes: [],
    }
  },
  computed: {
    processData() {
      return this.secondaryProcessesData
    },
    tableFields() {
      const fields = [
        { key: 'process_title', sortable: true, label: i18n.t('DEBTIA_PROCESS_NAME') },
        {
          key: 'current_module',
          thStyle: { width: '40%' },
          tdStyle: { textAlign: 'center' },
          sortable: true,
        },
        {
          key: 'next_module',
          sortable: true,
          thStyle: { textAlign: 'center' },
          label: i18n.t('DEBTIA_NEXT_MODULE'),
          tdClass: 'text-center',
        },
        {
          key: 'action',
          label: '',
          tdClass: 'text-center',
        },
      ]
      return fields
    },
  },
  created() {
    this.getProcesses()
    // this.processID = this.currentProcessId
  },
  methods: {
    deleteProcess(item) {
      this.$swal({
        title: i18n.t('DEBTIA_SURE'),
        text: `Are you sure you want to unassign the '${item.process_title}' from this case?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.isConfirmed) {
          const url = '/process/case/cancel-process'
          const obj = {
            process_case_id: item.process_id,
            case_id: this.caseId,
          }
          await axios.post(url, obj).then(response => {
            if (response.status === 200) {
              this.errorMsg = ''
              this.$refs['modal-assign-secondary-process'].hide()
              EventBus.$emit('refreshLogs')
              this.getSecondaryProcesses()
            }
          })
        }
      })
    },
    async getProcesses() {
      const url = '/process/get-processes-dropdown?type=secondary'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.processes = response.data.data.processes
        }
      })
    },
    submitHandler(evt) {
      evt.preventDefault()
      this.loader = true
      axios.post('/process/case/add-secondary', {
        process_id: this.processID,
        case_id: this.caseId,
      }).then(response => {
        if (response.status === 200) {
          this.errorMsg = ''
          this.loader = false
          this.processChangeCheck = false
          this.$refs['modal-assign-secondary-process'].hide()
          this.getSecondaryProcesses()
          EventBus.$emit('refreshLogs')
          EventBus.$emit('refreshModules')
          EventBus.$emit('refreshStatmentWidget')
          EventBus.$emit('refreshStateData')
          EventBus.$emit('refreshBetalingInvoices')
          EventBus.$emit('refreshDocuments')
          EventBus.$emit('refreshInstallmentPlan')
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Success',
              icon: 'CoffeeIcon',
              variant: 'primary',
              text: i18n.t('DEBTIA_PROCESS_ASSIGNED_MESSAGE'),
            },
          })
          this.processID = 0
        }
      }).catch(error => {
        this.loader = false
        this.errorMsg = error.response.data.message
      })
    },
    resetProcessChangeModal() {
      this.processID = this.currentProcessId
      this.errorMsg = ''
    },
  },
}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .error-color {
    color: red !important;
  }

  .main-text {
    margin: 10px 0px 0px 13px;
  }
  .assign-sec-proccess td{
    white-space: normal !important;
  }
  </style>
